/**
 * Controller for command handling
 * 
 * Listens to command events and calls appropriate history methods.
 * Provides convenience functions for undo/redo.
 */

import { bus } from './events.js';
import { history } from './history.js';

// Listen to command events and call history:
bus.on('command.undo', () => history.undo());
bus.on('command.redo', () => history.redo());

/**
 * Convenience function to trigger undo.
 * Emits command.undo event which is handled by history manager.
 */
export function undo(): void {
  bus.emit('command.undo', {});
}

/**
 * Convenience function to trigger redo.
 * Emits command.redo event which is handled by history manager.
 */
export function redo(): void {
  bus.emit('command.redo', {});
}

